<template>
  <div class="eleMenu">
    <div
      v-show="!isCollapse"
      class="topLogo">
      <div class="center_c">
        <img
          src="@/assets/img/csbcLogo.png"
          class="top_logo_img"
          alt="logo" >
        <div class="userInfo">
          <div class="center_c_user">
            <div class="lf_c">
              <i class="el-icon-user-solid" />
            </div>
            <p class="rg_c">{{$user.userName}}</p>
          </div>
        </div>
      </div>
    </div>
    <el-menu
      :default-active="`/${$user.activeMenu}`"
      :router="false"
      :unique-opened="true"
      :collapse="isCollapse"
      background-color="#0A1A43"
      text-color="#8895B8"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      @select="select"
    >
      <el-submenu
        v-for="(item, idx) in menuList"
        :index="idx + 1 + ''"
        :key="idx"
      >
        <template slot="title">
          <i
            v-if="idx == 0"
            class="el-icon-pie-chart" />
          <i
            v-if="idx == 1"
            class="el-icon-folder" />
          <i
            v-if="idx == 2"
            class="el-icon-aim" />
          <i v-if="idx == 3" class="el-icon-data-line" />
          <i
            v-if="idx == 4"
            class="el-icon-setting" />
            <span>{{ $i18n.locale === 'zh-CN' ? item.fatherMenuName : item.fatherMenuEng }}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item
            v-for="(data, index) in item.childMenuList"
            :key="index"
            :index="data.authUrl"
          >
            <div class="active_box" >{{ $i18n.locale === 'zh-CN' ? data.childMenuName: data.childMenuEng }}</div>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import routerList from './routerList';
export default {
  props: {
    menuStatus: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      route: true,
      isCollapse: false,
      titles: '',
      menuList: [],
      routerList: JSON.parse(sessionStorage.getItem('tabrouterList'))
    };
  },
  computed: {
    ...mapGetters(['$menu', '$user'])
  },
  watch: {
    menuStatus: {
      handler (newV) {
        console.log(newV);
        if (newV === 'el-icon-s-unfold') {
          this.isCollapse = true;
        } else {
          this.isCollapse = false;
        }
      }
    },
    $route (to, from) {
      let menuArr = [];
      this.routerList.forEach(el => {
        menuArr.push(el.routerName);
      });
      if (menuArr.indexOf(to.name) >= 0) {
        this.$store.commit('set_active_menu', to.name);
      }
    }
  },
  created () {
    this.menuList = this.$menu.list;
  },
  methods: {
    ...mapActions(['GetName']),
    handleOpen (val) {},
    select (val) {
      if (this.$route.path !== val) {
        this.$router.push({
          path: val
        });
        this.GetName(val);
      }
    },
    handleClose () {}
  }
};
</script>

<style lang="less" scoped>
.eleMenu {
  height: 100%;
  overflow-y: overlay;
  background: #0a1a43;
  box-shadow: 2px 2px 11px 0px #e3e6f2;
  .topLogo {
    min-width: 200px;
    height: 158px;
    padding: 21px 22px 28px 22px;
    box-sizing: border-box;
    .center_c {
      width: 100%;
      height: 100%;
      .top_logo_img {
        width: 122.05px;
        height: 36.4px;
        display: block;
        margin: auto;
        margin-bottom: 28px;
      }
      .userInfo {
        display: flex;
        justify-content: center;
        .center_c_user {
          margin: auto;
          display: flex;
          align-items: center;
          .lf_c {
            margin-right: 12px;
            width: 45px;
            height: 45px;
            border-radius: 50%;
            background: linear-gradient(82deg, #3a97ff 0%, #246fff 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
          }
          .rg_c {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #d0d0d0;
          }
        }
      }
    }
  }
  .el-menu-vertical-demo {
    height: calc(100%-158px);
  }
}
.menuTitle {
  font-size: 14px;
  border-bottom: 1px solid #d2d2d2;
}

.menuTitle:last-child {
  border: 0;
}

.eleMenu-ul {
  background: #fff;
  border: 1px solid #e5e5e5;
}

.menuList {
  height: 36px;
  line-height: 36px;
  text-indent: 19px;
}

.menuTitle > h3 > i {
  float: left;
  margin-top: 8px;
  font-size: 18px;
  text-indent: 15px;
}

.menuTitle > div {
  text-indent: 55px;
}
.el-menu-item {
  padding: 0 !important;
  width: 100%;
  height: 45px;
  line-height: 45px;
  .active_box {
    width: 80%;
    padding-left: 52.5px;
    box-sizing: border-box;
  }
}

.el-submenu .el-menu-item .img-def {
  display: inline-block;
}

.el-submenu .el-menu-item .img-act {
  display: none;
}
/deep/.el-menu-item.is-active {
  border-left: none;
  color: #ffffff;
  // padding-left: 40 !important;
  .active_box {
    width: 75%;
    background-color: #2c6df3 !important;
    border-radius: 0px 100px 100px 0px;
    box-sizing: border-box;
  }
}

.el-menu-item.is-active .img-def {
  display: none;
}

.el-menu-item.is-active .img-act {
  display: inline-block;
}

.el-menu-item:hover .img-def {
  display: none;
}

.el-menu-item:hover .img-act {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/eleMenu.vue